import { ConfigFn } from '@config/types'

const config = (({ deploymentEnv }) =>
  ({
    onboardingUrl:
      deploymentEnv === 'prod'
        ? 'https://link.blick.ch/manage/6ma/blickplus-onboarding'
        : 'https://link-ssr.stg.blick.ch/manage/6mg/blickplus-onboarding',
  }) as const) satisfies ConfigFn

export default config
